(function () {
  const ATTRIBUTE_NAME = 'engraving_summary';
  let isSyncing = false;
  let shouldSyncAgain = false;

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function buildCartUrl(path) {
    const root = getShopifyRoot();
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

    return `${normalizedRoot}${path}`;
  }

  function getCartJsonUrl() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      return buildCartUrl('cart.js');
    }

    if (window.routes && window.routes.cart_url) {
      return `${window.routes.cart_url}.js`;
    }

    return buildCartUrl('cart.js');
  }

  function getCartUpdateUrl() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      return buildCartUrl('cart/update.js');
    }

    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }

    return buildCartUrl('cart/update.js');
  }

  function getProperty(properties, name) {
    if (!properties || typeof properties !== 'object') return '';

    const value = properties[name];
    return typeof value === 'string' ? value.trim() : value || '';
  }

  function buildEngravingSummary(items) {
    const lines = [];
    const seen = new Set();

    if (!Array.isArray(items)) return '';

    items.forEach((item) => {
      const properties = item && item.properties;
      const engraving = getProperty(properties, 'Engraving');

      if (!engraving) return;

      const targetProductId = getProperty(properties, '_engraving_target_product_id');
      const targetTitle = getProperty(properties, '_engraving_target_title');
      const title = targetTitle || item.product_title || item.title || item.name || 'Engraved product';
      const dedupeKey = [targetProductId || title, engraving].join('::');

      if (seen.has(dedupeKey)) return;

      seen.add(dedupeKey);
      lines.push(`${title}: ${engraving}`);
    });

    return lines.join('\n');
  }

  function postEngravingSummary(summary) {
    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_NAME]: summary || '',
        },
      }),
    });
  }

  // Backup for Shopify Bundles / Order Printer Pro:
  // keep the existing line item properties unchanged, and mirror a cart-level
  // engraving summary after the cart has actually changed.
  window.syncEngravingCartAttribute = function () {
    if (isSyncing) {
      shouldSyncAgain = true;
      return Promise.resolve();
    }

    isSyncing = true;
    shouldSyncAgain = false;

    return fetch(getCartJsonUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Could not fetch cart for engraving summary.');
        return response.json();
      })
      .then((cart) => postEngravingSummary(buildEngravingSummary(cart.items)))
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        isSyncing = false;

        if (shouldSyncAgain) {
          window.syncEngravingCartAttribute();
        }
      });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.syncEngravingCartAttribute();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.syncEngravingCartAttribute);
  } else {
    window.syncEngravingCartAttribute();
  }
})();
